module.exports = __webpack_public_path__ + "static/media/perfect-piano.8c7c9e40.jpg";